import React, { Component } from "react";
import PropTypes from "prop-types";
import { DragSource } from "react-dnd";
import ItemTypes from "./ItemTypes";
import track from "../lib/tracking"

const targetItemSource = {
  beginDrag(props) {
    props.setDragging(props.id, -1, -1, true);
    return {
      id: props.id,
      type: ItemTypes.SEARCHCARD,
      target: props.target
    };
  },
  isDragging(props, monitor) {
    return props.id === monitor.getItem().id;
  },
  endDrag(props) {
    props.setDragging(-1, -1, -1, false);
    props.cleanTargets();
  }
};

const drag = () =>
  DragSource(ItemTypes.SEARCHCARD, targetItemSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  }));
class SearchTarget extends Component {
  static propTypes = {
    connectDragSource: PropTypes.func.isRequired,
    isDragging: PropTypes.bool.isRequired,
    id: PropTypes.any.isRequired
  };

  render() {
    const { target, isDragging, connectDragSource, addTarget } = this.props;
    const opacity = isDragging ? 0 : 1;

    return connectDragSource(
      <div
        style={{ opacity }}
        className="option bg-gray"
        key={target.id + target.type}
      >
        <p className="option__label">
          {target.name}
        </p>
        <span className="option__tag">
          {target.type.replace(/_/g, " ")}
        </span>
        <div className="option__actions">
          <button
            className="option__action"
            onClick={() => {track("target_added",{target: target.name,method: "or"});addTarget(target, 0);}}
          >
            OR
          </button>
          <button
            className="option__action"
            onClick={() => {track("target_added",{target: target.name,method: "or"});addTarget(target, 1)}}
          >
            AND
          </button>
        </div>
      </div>
    );
  }
}
export default drag()(SearchTarget);



// WEBPACK FOOTER //
// ./src/components/SearchTarget.js